gsap.registerPlugin(ScrollTrigger);

class CanCta extends HTMLElement {
    connectedCallback() {
        this.tooltip = this.querySelector('[data-can-tooltip]');
        if (!this.tooltip) return;

        this.links = this.querySelectorAll('a[data-flavor-name]');
        this.background = this.querySelector('[data-can-background]');
        this.left = this.querySelector('[data-can-left]');
        this.right = this.querySelector('[data-can-right]');
        this.centered = this.querySelector('[data-can-centered]');

        this.canTrackPointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

        this.lastX = 0;
        this.lastY = 0;

        gsap.set(this.tooltip, { rotate: 10, autoAlpha: 0 });

        this.mm = gsap.matchMedia();
        this.mm.add('(min-width: 1024px)', () => {
            this.initTimeline();
            return () => {
                this.timeline?.kill();
                this.timeline = null;
            };
        });
        this.mm.add('(max-width: 1023px) and (prefers-reduced-motion: no-preference)', () => {
            this.initMobileTimeline();
            return () => {
                this.timeline?.kill();
                this.timeline = null;
            };
        });

        this.linkHandlers = [];

        // Touch devices fire mouseenter on tap, which flashed the tooltip before navigating
        if (!this.canTrackPointer) return;

        this.addEventListener('pointermove', this.handlePointerMove);

        this.links.forEach((link) => {
            const flavorName = link.getAttribute('data-flavor-name');

            const enter = (e) => {
                this.lastX = e.clientX;
                this.lastY = e.clientY;
                this.showTooltip(flavorName);
            };

            const leave = () => this.hideTooltip();

            link.addEventListener('mouseenter', enter);
            link.addEventListener('mouseleave', leave);

            this.linkHandlers.push({ link, enter, leave });
        });
    }

    disconnectedCallback() {
        if (this.canTrackPointer) {
            this.removeEventListener('pointermove', this.handlePointerMove);
        }

        this.linkHandlers?.forEach(({ link, enter, leave }) => {
            link.removeEventListener('mouseenter', enter);
            link.removeEventListener('mouseleave', leave);
        });

        this.mm?.revert();
        this.mm = null;

        this.timeline = null;
    }

    handlePointerMove = (e) => {
        if (!this.canTrackPointer) return;

        this.lastX = e.clientX;
        this.lastY = e.clientY;

        const x = Math.min(window.innerWidth - 120, this.lastX + 12);
        const y = Math.max(20, this.lastY - 36);

        gsap.to(this.tooltip, {
            x,
            y,
            duration: 0.2,
            ease: 'expo.out',
            overwrite: 'auto',
        });
    };

    initTimeline() {
        this.timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.centered,
                start: 'top bottom',
            },
        });

        this.timeline
            .from(this.background, { opacity: 0, scale: 0.7, duration: 4, ease: 'expo.out' })
            .from(this.centered, { scale: 1.4, duration: 3.8, ease: 'expo.out' }, '<')
            .from(this.left, { left: 0, duration: 1.5, ease: 'smooth' }, '<')
            .from(this.right, { right: 0, duration: 1.5, ease: 'smooth' }, '<');
    }

    // Lighter version of the desktop intro: shorter, and only transform/opacity so it stays smooth on phones
    initMobileTimeline() {
        this.timeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.centered,
                start: 'top 85%',
            },
        });

        this.timeline
            .from(this.background, { opacity: 0, scale: 0.8, duration: 1.6, ease: 'expo.out' })
            .from(this.centered, { scale: 1.2, duration: 1.5, ease: 'expo.out' }, '<')
            .from(this.left, { x: '21.5vw', duration: 1, ease: 'power2.out' }, '<')
            .from(this.right, { x: '-21.5vw', duration: 1, ease: 'power2.out' }, '<');
    }


    showTooltip(flavorName) {
        this.tooltip.querySelector('[data-can-tooltip-text]').textContent = flavorName;

        gsap.set(this.tooltip, {
            x: this.lastX + 12,
            y: this.lastY - 36,
        });

        gsap.to(this.tooltip, {
            autoAlpha: 1,
            rotate: 0,
            duration: 0.25,
            ease: 'expo.out',
            overwrite: 'auto',
        });
    }

    hideTooltip() {
        gsap.to(this.tooltip, {
            autoAlpha: 0,
            rotate: 10,
            duration: 0.25,
            ease: 'expo.out',
            overwrite: 'auto',
        });
    }
}

customElements.define('can-cta', CanCta);